import React, { useState, useEffect } from 'react';
import { Accordion, Icon, Segment } from 'semantic-ui-react';

interface AccordionItem {
  title: string;
  content: React.ReactNode;
}

interface AccordionData {
  items?: AccordionItem[];
  styled?: boolean;
  fluid?: boolean;
  exclusive?: boolean;
  wrapped?: boolean;
}

interface AccordionViewProps {
  data?: AccordionData;
}

const AccordionView = ({ data = {} }: AccordionViewProps) => {
  const {
    items = [],
    styled = false,
    fluid = true,
    exclusive = true,
    wrapped = false,
  } = data;

  const [activeIndex, setActiveIndex] = useState<number | number[]>(
    exclusive ? -1 : []
  );

  useEffect(() => {
    setActiveIndex(exclusive ? -1 : []);
  }, [exclusive]);

  const handleClick = (index: number): void => {
    if (exclusive) {
      setActiveIndex(activeIndex === index ? -1 : index);
    } else {
      const newIndexes = Array.isArray(activeIndex)
        ? [...activeIndex]
        : [];

      if (newIndexes.includes(index)) {
        setActiveIndex(newIndexes.filter((i) => i !== index));
      } else {
        setActiveIndex([...newIndexes, index]);
      }
    }
  };

  if (!items.length) {
    return null;
  }

  const accordion = (
    
    <Accordion styled={styled} fluid={fluid}>
      {items.map((item, index) => {
        const isActive = exclusive
          ? activeIndex === index
          : Array.isArray(activeIndex) && activeIndex.includes(index);

        return (
          <React.Fragment key={index}>
            <Accordion.Title
              active={isActive}
              index={index}
              onClick={() => handleClick(index)}
            >
              <Icon name="dropdown" />
              {item.title}
            </Accordion.Title>

            <Accordion.Content active={isActive}>
              <p>{item.content}</p>
            </Accordion.Content>
          </React.Fragment>
        );
      })}
    </Accordion>
  );

  return wrapped ? <Segment>{accordion}</Segment> : accordion;
};

export default AccordionView;